import React from "react";
import Select from "react-select";
import { RaisedButton, TextField } from "material-ui";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import DateTimeUtil from "../../../utils/DateTimeUtil";

class ExpiredPassScheduleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBucket: null,
      expiredPassTimePeriod: 14
    };

    this.handleParentStateUpdate = this.handleParentStateUpdate.bind(this);
  }

  componentDidMount() {
    const item = this.props.item;
    this.setState({
      selectedBucket: {
        value:
          item.event_bucket && item.event_bucket.length > 0
            ? item.event_bucket[0]._id
            : null
      },
      expiredPassTimePeriod:
        item.conditions && item.conditions.expiredPassTimePeriod
          ? item.conditions.expiredPassTimePeriod
          : null
    });
  }

  handleParentStateUpdate() {
    let parentState = {
      conditions: {}
    };
    if (this.state.selectedBucket) {
      parentState.selectedBuckets = [this.state.selectedBucket.value];
    }
    if (this.state.expiredPassTimePeriod) {
      parentState.conditions.expiredPassTimePeriod =
        this.state.expiredPassTimePeriod;
    }
    const isComplete =
      this.state.selectedBucket !== null &&
      this.state.expiredPassTimePeriod !== null;

    this.props.update(parentState, isComplete);
  }

  getStyles() {
    return {
      fieldLabel: {
        color: "#737373",
        fontWeight: "bold",
        marginBottom: 2
      }
    };
  }

  render() {
    const styles = this.getStyles();

    return (
      <div>
        <div
          style={{
            clear: "both",
            float: "left",
            paddingTop: "10px",
            marginRight: "25px"
          }}
        >
          <div style={styles.fieldLabel}>Event Bucket</div>
          <Select
            style={{ width: "400px" }}
            clearable={false}
            autosize={false}
            multi={false}
            placeholder="No event bucket selected"
            value={
              this.state.selectedBucket ? this.state.selectedBucket.value : null
            }
            options={this.props.eventBuckets}
            onChange={value => {
              this.setState(
                { selectedBucket: value },
                this.handleParentStateUpdate
              );
            }}
          />
        </div>
        <div style={{ float: "left", paddingTop: "10px" }}>
          <div style={styles.fieldLabel}>Expired passes in the past</div>
          <Select
            style={{ width: "300px" }}
            clearable={false}
            autosize={false}
            multi={false}
            value={this.state.expiredPassTimePeriod}
            options={[
              { label: "90 days", value: 90 },
              { label: "1 year", value: 365 },
              { label: "2 years", value: 730 },
              { label: "3 years", value: 1095 }
            ]}
            onChange={e => {
              this.setState({ expiredPassTimePeriod: e.value }, () => {
                this.handleParentStateUpdate();
              });
            }}
          />
        </div>
      </div>
    );
  }
}

export default ExpiredPassScheduleView;



// WEBPACK FOOTER //
// ./src/app/components/partials/schedule-views/expired-pass-schedule-view.jsx